import api from '../../utils/api'

const API_BASE_URL = "/ast/ASTSparepart";

const ASTSparepartService = {
  async findAll(recordFilter: any): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-all`, {
      params: recordFilter,
    });
    return response.data;
  },

  async getItemById(sparepartId: string): Promise<any> {
    const response = await api.get(`${API_BASE_URL}/find-one/${sparepartId}`);
    return response.data;
  },

  async create(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/create`, item);
    return response.data;
  },

  async update(sparepartId: string, item: any): Promise<any> {
    const response = await api.put(`${API_BASE_URL}/update/${sparepartId}`, item);
    return response.data;
  },

  async delete(sparepartId: string): Promise<any> {
    const response = await api.delete(`${API_BASE_URL}/delete/${sparepartId}`);
    return response.data;
  },

  async instock(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/instock`, item);
    return response.data;
  },

  async outstock(item: any): Promise<any> {
    const response = await api.post(`${API_BASE_URL}/outstock`, item);
    return response.data;
  }

};

export default ASTSparepartService;